export enum FILES_TABLES {
  VehicleFiles = "Vehicle files",
  DriverFiles = "Driver files",
}
